// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-reg-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.schedule-reg-modal__content {
  width: 700px;
  background: #ffffff;
  padding: 42px 32px 32px 32px;
  border-radius: 16px;
}
.schedule-reg-modal__action__close {
  cursor: pointer;
}

.schedule-reg__header {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 41px;
  color: #353d47;
}
.schedule-reg__body {
  margin-top: 20px;
}
.schedule-reg__dropdown {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
.schedule-reg__label {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.schedule-reg__select {
  margin-top: 20px;
}
.schedule-reg__time-pick {
  display: flex;
  margin-top: 20px;
  flex-direction: column;
}
.schedule-reg__time-pick__time {
  display: flex;
}
.schedule-reg__time-pick__start {
  width: 50%;
  margin-right: 20px;
}
.schedule-reg__time-pick__dash {
  padding-top: 15px;
}
.schedule-reg__time-pick__end {
  width: 50%;
  margin-left: 20px;
}
.schedule-reg__calendar-section {
  flex: 1 1;
  display: flex;
  width: 100%;
}
.schedule-reg__calendar-section__additional-sche {
  flex: 1 1;
  display: flex;
  margin-left: 5%;
  flex-direction: column;
  max-height: 340px;
}
.schedule-reg__calendar-section__additional-sche__head {
  display: flex;
  align-content: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.schedule-reg__calendar-section__additional-sche__schedules {
  flex: 1 1;
  margin-top: 10px;
  max-height: calc(100% - 30px);
  overflow-y: auto;
}
.schedule-reg__calendar-section__additional-sche__label {
  padding: 5px;
}
.schedule-reg__allowance-section {
  margin-top: 30px;
}
.schedule-reg__allowance {
  display: flex;
  margin-top: 10px;
}
.schedule-reg__allowance__radio {
  margin-right: 20px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #999999;
}
.schedule-reg__allowance__radio-active {
  margin-right: 20px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.schedule-reg__note {
  margin-top: 20px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  color: #bd1823;
}
.schedule-reg__buttons {
  display: flex;
  margin-top: 40px;
}
.schedule-reg__buttons__cancel {
  width: 100%;
  margin-right: 5px;
}
.schedule-reg__buttons__save {
  width: 100%;
  margin-left: 5px;
}

.react-calendar {
  border: 1px solid #e9e9e9;
  border-radius: 16px;
  padding: 10px;
}

.react-calendar__month-view__days__day {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  align-items: center;
  text-align: center;
  color: #505054;
  height: 45px !important;
}

.react-calendar__month-view__weekdays__weekday {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  color: #c1c1c1;
}

.react-calendar__navigation__arrow {
  font-size: 2rem;
}

.react-calendar__navigation__label {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  align-items: center;
  text-align: center;
  color: #333333;
  pointer-events: none;
}

.react-calendar__tile--active {
  color: #505054 !important;
  background: none !important;
}

.react-calendar__tile--now {
  background: none !important;
}

.react-calendar__tile--active:enabled:hover, .react-calendar__tile--now:enabled:hover, .react-calendar__tile--now:enabled:focus {
  background: #e6e6e6 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/commuting/schedule-reg-modal/schedule-reg-modal.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AACI;EACI,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;AACR;AAGQ;EACI,eAAA;AADZ;;AAOI;EACI,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAJR;AAOI;EACI,gBAAA;AALR;AAQI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAPR;AAUI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARR;AAWI;EACI,gBAAA;AATR;AAYI;EACI,aAAA;EACA,gBAAA;EACA,sBAAA;AAVR;AAYQ;EACI,aAAA;AAVZ;AAaQ;EACI,UAAA;EACA,kBAAA;AAXZ;AAcQ;EACI,iBAAA;AAZZ;AAeQ;EACI,UAAA;EACA,iBAAA;AAbZ;AAiBI;EACI,SAAA;EACA,aAAA;EACA,WAAA;AAfR;AAqBQ;EACI,SAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AAnBZ;AAqBY;EACI,aAAA;EACA,qBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAnBhB;AAsBY;EACI,SAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;AApBhB;AAuBY;EACI,YAAA;AArBhB;AA0BI;EACI,gBAAA;AAxBR;AA2BI;EACI,aAAA;EACA,gBAAA;AAzBR;AA2BQ;EACI,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAzBZ;AA4BQ;EACI,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA1BZ;AA8BI;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AA5BR;AA+BI;EACI,aAAA;EACA,gBAAA;AA7BR;AA+BQ;EACI,WAAA;EACA,iBAAA;AA7BZ;AAgCQ;EACI,WAAA;EACA,gBAAA;AA9BZ;;AAmCA;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;AAhCJ;;AAgDA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;AA7CJ;;AAgDA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AA7CJ;;AAgDA;EACI,eAAA;AA7CJ;;AAgDA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;AA7CJ;;AA+CA;EACI,yBAAA;EACA,2BAAA;AA5CJ;;AA8CA;EACI,2BAAA;AA3CJ;;AA6CA;EACI,8BAAA;AA1CJ","sourcesContent":[".schedule-reg-modal {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &__content {\n        width: 700px;\n        background: #ffffff;\n        padding: 42px 32px 32px 32px;\n        border-radius: 16px;\n    }\n\n    &__action {\n        &__close {\n            cursor: pointer;\n        }\n    }\n}\n\n.schedule-reg {\n    &__header {\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 28px;\n        line-height: 41px;\n        color: #353d47;\n    }\n\n    &__body {\n        margin-top: 20px;\n    }\n\n    &__dropdown {\n        width: 100%;\n        height: 56px;\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n    }\n\n    &__label {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n    }\n\n    &__select {\n        margin-top: 20px;\n    }\n\n    &__time-pick {\n        display: flex;\n        margin-top: 20px;\n        flex-direction: column;\n\n        &__time {\n            display: flex;\n        }\n\n        &__start {\n            width: 50%;\n            margin-right: 20px;\n        }\n\n        &__dash {\n            padding-top: 15px;\n        }\n\n        &__end {\n            width: 50%;\n            margin-left: 20px;\n        }\n    }\n\n    &__calendar-section {\n        flex: 1;\n        display: flex;\n        width: 100%;\n\n        &__cal {\n            \n        }\n\n        &__additional-sche {\n            flex: 1;\n            display: flex;\n            margin-left: 5%;\n            flex-direction: column;\n            max-height: 340px;\n\n            &__head {\n                display: flex;\n                align-content: center;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 500;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n\n            &__schedules {\n                flex: 1;\n                margin-top: 10px;\n                max-height: calc(100% - 30px);\n                overflow-y: auto;\n            }\n\n            &__label {\n                padding: 5px;\n            }\n        }\n    }\n\n    &__allowance-section {\n        margin-top: 30px;\n    }\n\n    &__allowance {\n        display: flex;\n        margin-top: 10px;\n\n        &__radio {\n            margin-right: 20px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 24px;\n            color: #999999;\n        }\n\n        &__radio-active {\n            margin-right: 20px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 24px;\n            color: #333333;\n        }\n    }\n\n    &__note {\n        margin-top: 20px;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        align-items: center;\n        color: #bd1823;\n    }\n\n    &__buttons {\n        display: flex;\n        margin-top: 40px;\n\n        &__cancel {\n            width: 100%;\n            margin-right: 5px;\n        }\n\n        &__save {\n            width: 100%;\n            margin-left: 5px;\n        }\n    }\n}\n\n.react-calendar {\n    border: 1px solid #e9e9e9;\n    border-radius: 16px;\n    padding: 10px;\n    // height: 318px;\n    // width: 310;\n}\n\n// .react-calendar__tile:enabled:focus {\n//     background-color: #fff !important;\n// }\n\n// .react-calendar__tile--active {\n//     background: #075453 !important;\n//     border-radius: 50%;\n//     height: 45px !important;\n//     width: 40px !important;\n// }\n\n.react-calendar__month-view__days__day {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    align-items: center;\n    text-align: center;\n    color: #505054;\n    height: 45px !important;\n}\n\n.react-calendar__month-view__weekdays__weekday {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    align-items: center;\n    text-align: center;\n    color: #c1c1c1;\n}\n\n.react-calendar__navigation__arrow {\n    font-size: 2rem;\n}\n\n.react-calendar__navigation__label {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 22px;\n    align-items: center;\n    text-align: center;\n    color: #333333;\n    pointer-events: none;\n}\n.react-calendar__tile--active {\n    color: #505054 !important;\n    background: none !important;\n}\n.react-calendar__tile--now {\n    background: none !important;\n}\n.react-calendar__tile--active:enabled:hover, .react-calendar__tile--now:enabled:hover, .react-calendar__tile--now:enabled:focus {\n    background: #e6e6e6 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
